import ConditionalWrapper from "@components/common/ConditionalWrapper";
import { slashBeforeUrlAdder } from "@components/utils/urlHelpers";
import { IImageComponentResponse } from "@customTypes/componentResponses";
import { ITag } from "@modules/requestAQuote/components/TripPreferences";
import Link from "next/link";
import GalleryHeader from "./GalleryHeader";
import CardBody from "./components/CardBody";
import { CardTypeType } from "./utils/constants";

interface IModalCard {
  id: number;
  title?: string;
  isTitleLocation?: boolean;
  subtitle?: string;
  blurb?: string;
  tags?: ITag[];
  priceRate?: number;
  url?: string;
  opensNewTab?: boolean;
  hasLike?: boolean;
  linkTitle?: string;
  images?: string[] | IImageComponentResponse[] | null;
  imageSize?: string;
  cardType?: CardTypeType;
  tagLeftTag?: {
    id: number;
    title: string | undefined;
  };
  isHorizontal: boolean;
}

const ModalCard = ({
                     title,
                     isTitleLocation,
                     subtitle,
                     blurb,
                     tags,
                     priceRate,
                     url,
                     opensNewTab,
                     linkTitle,
                     images,
                     imageSize,
                   }: IModalCard): JSX.Element => {
  return (
    <ConditionalWrapper
      condition={!!url}
      wrapper={(children) => (
        <Link
          href={url ? slashBeforeUrlAdder(url) : ""}
          target={opensNewTab ? "_blank" : undefined}
          prefetch={false}
        >
          {children}
        </Link>
      )}
    >
      <div className="flex flex-row gap-[2.375rem]">
        <div className="h-[240px] w-[20.25rem]">
          <GalleryHeader
            responsiveGridConfig={{
              mobile: {
                itemsPerRow: 1,
                itemHeight: 490,
              },
            }}
            title={title}
            tags={tags}
            images={images?.slice(0,1)}
            imageSize={imageSize}
          />
        </div>
        <CardBody
          title={title}
          isTitleLocation={isTitleLocation}
          location={subtitle}
          blurb={blurb}
          priceRate={priceRate}
          url={url}
          opensNewTab={opensNewTab}
          linkTitle={linkTitle}
        />
      </div>
    </ConditionalWrapper>
  );
};

export default ModalCard;
